"use client";
import "./Categories.scss";
import { categories } from "@/utils/DefaultValues";
import { useThemeContext } from "@/context/ThemeContext";
import { nameSlug } from "@/utils/Functions/NameSlug";
import Link from "next/link";

export default function Categories() {
  const { theme } = useThemeContext();

  return (
    <div
      className={
        "categories-main-container " + (theme === "dark" ? "dark" : "light")
      }
    >
      <h1>Categories</h1>
      <div className="links-container">
        {categories.map((category, i) => {
          return (
            <Link
              href={`/categories/${nameSlug(category)}`}
              key={"link-" + category}
            >
              {category}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
